import { Search } from '@/DTOS/TimeKeeperDevice/Search';
import request from '../../utils/request';

const TimeKeeperSystemTypeService = {
  search: (search: Search) => {
    return request('/timeKeeperSystemType/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    id: any,
    formData: {
      name: any;
      location: any;
      ip: any;
      port: any;
      user: any;
      password: any;
    }
  ) => {
    return request('/timeKeeperSystemType/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          location: formData.location,
          ip: formData.ip,
          port: formData.port,
          user: formData.user,
          password: formData.password,
        },
      }),
    });
  },
};

export default TimeKeeperSystemTypeService;
